import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import pkg from '../../../package.json' with { type: 'json' };
import { LanguagePicker } from '../language-picker/language-picker.component';

@Component({
  selector: 'app-footer',
  imports: [LanguagePicker, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected currentYear: number;
  protected version = pkg.version ?? '0.0.0';

  constructor() {
    this.currentYear = new Date().getFullYear();
  }
}
